"use client";
import React from "react";
import { defaultContextData } from "./Toast.constants.js";
const context = React.createContext(defaultContextData);
export default context;
